import React from "react";
import { Handles, Rail, Slider } from "react-compound-slider";
import { ImageLevellingSliderHandle } from "./ImageLevellingSliderHandle";
import ImageLevellingSliderRail from "./ImageLevellingSliderRail";

type Props = {
  disabled: boolean;
  values: number[];
  min: number;
  max: number;
  step: number;
  onHandleDraged?: ((values: readonly number[]) => void) | undefined;
  onValuesChanged: (values: readonly number[]) => void;
  style?: React.CSSProperties;
};

export default function ImageLevelingSlider({
  disabled,
  values,
  min,
  max,
  step,
  onHandleDraged = undefined,
  onValuesChanged,
  style,
}: Props) {
  const domain = [min, max];
  return (
    <div
      style={{
        minHeight: 25,
        // border: "1px solid black",
        ...style,
      }}
    >
      <Slider
        disabled={disabled}
        rootStyle={{
          position: "relative",
          top: 12,
          left: 12,
          width: "calc(100% - 24px)",
          height: 24,
        }}
        domain={domain}
        step={step}
        mode={2}
        values={values}
        onUpdate={onHandleDraged}
        onChange={onValuesChanged}
      >
        <Rail>{({ getRailProps }) => <ImageLevellingSliderRail getRailProps={getRailProps} />}</Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <ImageLevellingSliderHandle
                  key={handle.id}
                  handle={handle}
                  domain={[min, max]}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
      </Slider>
    </div>
  );
}
